// Generic reducer to update any property in the state
export const updateStateProperty = (state, action) => {
    const { key, value } = action.payload;
    if (key in state) {
        state[key] = value;
    } else {
        console.warn(`Key "${key}" does not exist in the state.`);
    }
};